<template>
    <div>
        <div style="width: 90%; margin: auto; text-align: left">
            <p>隐私政策&nbsp;</p>
            <p><br /></p>
            <p>更新时间：2024-02-26</p>
            <p><br /></p>
            <p>序言：&nbsp;</p>
            <p><br /></p>
            <p>
                欢迎您使用惠有钱！惠有钱是由海南亿万未来科技有限公司（以下可简称“我们”）运营。我们非常重视对您个人信息的保护，并依据《中华人民共和国网络安全法》、《信息安全技术
                个人信息安全规范》及相关法律法规制定了《惠有钱隐私政策》（以下可简称“本政策”或“本隐私政策”）。&nbsp;
            </p>
            <p><br /></p>
            <p>以下是本隐私政策的要点说明：&nbsp;</p>
            <p><br /></p>
            <p>
                为帮助您注册并使用本产品或服务，我们可能收集与提供服务相关的个人信息，您有权拒绝或撤回授权；&nbsp;
            </p>
            <p><br /></p>
            <p>
                1）您可以访问、更正、删除您的个人信息，改变您授权同意的范围，注销您的帐号，我们为您提供了行使这些权利的途径。&nbsp;
            </p>
            <p><br /></p>
            <p>
                2）我们采取了互联网业内标准的技术措施和数据安全措施来保护您的个人信息安全。&nbsp;
            </p>
            <p><br /></p>
            <p>
                3）除非再次征得您的同意，我们不会将您的个人信息用于本隐私政策未载明的其他目的。&nbsp;
            </p>
            <p><br /></p>
            <p>
                4）当您对本隐私政策有任何疑问，可以和我们进一步联系与咨询。&nbsp;
            </p>
            <p><br /></p>
            <p>我们希望通过本政策帮助您了解以下内容：&nbsp;</p>
            <p><br /></p>
            <p>一、我们如何收集您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>二、我们如何使用您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>三、我们如何使用Cookie 和同类技术&nbsp;</p>
            <p><br /></p>
            <p>四、我们如何共享、转让、委托处理、公开披露您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>五、我们如何保护您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>六、您如何管理自己的个人信息&nbsp;</p>
            <p><br /></p>
            <p>七、我们如何处理未成年人的个人信息&nbsp;</p>
            <p><br /></p>
            <p>八、您个人信息的存储地点及存储时间&nbsp;</p>
            <p><br /></p>
            <p>九、对第三方责任的声明&nbsp;</p>
            <p><br /></p>
            <p>十、本政策的适用及修订&nbsp;</p>
            <p><br /></p>
            <p>十一、如何联系我们&nbsp;</p>
            <p><br /></p>
            <p>十二、本政策中关键词说明&nbsp;</p>
            <p><br /></p>
            <p>
                我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们在本隐私政策中所提及的收集、使用、共享、转让及管理的个人信息包括加粗及带有下划线标识的个人敏感信息以及其他的个人信息。我们致力于维持您对我们的信任，并恪守以下原则：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                请您在使用我们的产品或服务前，仔细阅读并确认您已经充分理解本政策所写明的内容，您点击确认后即视为您接受本政策的内容。&nbsp;
            </p>
            <p><br /></p>
            <p>1、我们如何收集您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>（一）用户注册和登录功能&nbsp;</p>
            <p><br /></p>
            <p>
                当您选择注册惠有钱时，您需要主动向我们提供您本人的手机号码，我们将通过向您提供的手机号码发送验证短信并收集您反馈的验证码的方式进行验证是您本人操作。手机号码和验证码为必要信息，如果您不提供，您将无法完成注册。当您登录惠有钱时，您需要主动向我们提供您本人的手机号码、验证码或密码，用于登录及进行验证是您本人操作，或者您可以使用“本机号码一键登录”的方式登录。&nbsp;
            </p>
            <p><br /></p>
            <p>（二）实名验证&nbsp;</p>
            <p><br /></p>
            <p>
                根据国家法律法规要求，当您使用我们的产品或服务时，我们可能需要首先认证您身份的真实性，为此您需要提供您的身份基本信息（姓名、身份证号码、性别、民族、身份证签发机关、身份证有效期、身份证地址、身份证正反面照片），以对您进行身份实名认证；您可能需要通过身份基本信息多重交叉验证后方可使用我们的部分服务，若需要通过刷脸进一步确认您提供信息的准确性时，我们还需要您提供脸部图像/视频。我们会将上述信息提交给合法持有您上述信息的第三方身份验证机构，以便对您所提供信息的准确性进行核对。如果您不提供上述信息或您的实名验证未通过，则您无法使用相关服务。&nbsp;
            </p>
            <p><br /></p>
            <p>（三）金融产品的申请功能&nbsp;</p>
            <p><br /></p>
            <p>
                当您申请惠有钱贷款产品时，您需要主动提供您的手机号码，以推送至您选择的贷款产品或服务的提供者，用于其与您取得联系向您提供贷款产品或服务；您需要主动填写或选择如下资质信息选项：姓名、性别、年龄、户籍、现居住地址、常用邮箱地址、教育程度、逾期信息、在贷情况、信用卡情况、社保情况、公积金情况、收入情况、职业状况、经营企业情况、房产状况、车辆状况、抵押状况、投保情况、紧急联系人姓名、联系电话及关系、本次贷款申请信息（以下可简称“资质信息”），用于我们对您进行产品匹配度初筛，并推送至您选择的贷款产品或服务的提供者对您进行信用审核、风险控制管理等与信贷相关的服务目的。&nbsp;
            </p>
            <p><br /></p>
            <p>
                当您申请惠有钱贷款产品时，我们需要收集您的姓名、手机号码、身份证号码、银行卡号、开户行、开户行地址，为您绑定银行卡，用于资金方向您发放贷款、为您提供还款服务。当您使用惠有钱提供的贷款产品还款服务时，我们可能会从贷款产品或服务的提供者处获取您的信贷审批信息、借款合同信息、还款计划信息、还款行为信息、贷款逾期信息、履约情况信息，用来对您进行身份核实、还款服务、账单管理、还款提醒、银行账户核实。&nbsp;
            </p>
            <p><br /></p>
            <p>
                以上部分信息属于敏感信息，均为完成产品申请所必要的信息，如果您拒绝提供上述全部信息，可能无法正常使用金融产品的申请服务，但不影响您使用我们提供的其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>（四）交易安全保障及金融风险控制所必需收集的信息&nbsp;</p>
            <p><br /></p>
            <p>
                为更准确地识别预防攻击和保护您的账户安全（包括形成风控标签/画像/模型、判断是否属于IP/设备黑名单、是否是真实设备/模拟器、是否安装风险软件/App等），我们将在您使用产品的过程中，自动收集设备信息或软件信息，例如设备MAC地址。请您注意我们收集的场景可能包括在惠有钱APP切换到后台的情况下。上述信息的收集频次我们会基于安全和风控所需的最小频次进行收集和上传，在您每次打开APP时，我们会将唯一设备识别符IMEI,
                MAC, 设备
                ID的上传频次控制在两次以内。我们将通过访问权限最小化、访问日志记录、与订单信息分开存储与授权等安全措施来保护这些设备和软件信息。&nbsp;
            </p>
            <p><br /></p>
            <p>（五）我们从其他来源间接收集您的信息：&nbsp;</p>
            <p><br /></p>
            <p>
                为了向您提供您申请的产品或服务，我们可能需要从信用机构、提供数据服务的第三方获取您的身份识别信息、风险识别信息，资质评估信息、表征信用情况的综合评分或信用评级，用于对您的信用状况进行评估。&nbsp;
            </p>
            <p><br /></p>
            <p>（六）我们的APP权限获取说明&nbsp;</p>
            <p><br /></p>
            <p>
                在您使用我们的产品或服务时，我们可能需要向您申请下列与个人信息相关的系统敏感权限：&nbsp;
            </p>
            <p><br /></p>
            <p>
                1、位置权限：当您安装或运行惠有钱APP时，我们会向您申请获取此权限，目的是为了基于您所在地点位置为您提供服务。若您不开启此权限，您可能因此无法使用我们提供的部分与位置信息相关的服务，但不影响您继续使用我们提供的其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、相机权限：当您使用惠有钱APP申请服务时，您需要开通相机权限，在身份验证的场景下，需要调用您的摄像头进行身份证的拍摄。在需要人脸识别的场景下，则需要调用您的摄像头进行人脸的拍摄。若您不开启此权限，您将无法使用与身份验证或人脸识别相关的功能，但不影响您继续使用我们提供的其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                3、读写外部存储权限：当您使用荷包钱包APP申请服务时，您需要通过开启存储权限保存视频或文件或图片（包括您拍摄的身份证图片、人脸图片）。若您不开启此权限，您将无法使用与身份验证或人脸识别相关的功能，但不影响您继续使用我们提供的其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                4、读取设备信息权限：当您使用惠有钱APP申请服务时，您需要开启读取设备信息权限。我们收集的数据可能包括但不限于SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEI）、设备型号、设备ID、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。在视频认证的场景下，需要调用此权限收集您的设备信息。若您不开启此权限，您将无法使用视频认证相关的功能，但不影响您继续使用我们提供的其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                除上述权限之外，您可自主选择是否额外授予惠有钱APP其他的系统权限。&nbsp;
            </p>
            <p><br /></p>
            <p>（七）征得授权同意的例外&nbsp;</p>
            <p><br /></p>
            <p>
                您理解并同意，根据相关国家法律法规及国家标准规定，我们在以下情况下收集、使用您的个人信息无需征得您的授权同意，且我们可能不会响应您提出的更改、修改、删除、注销、撤回同意、索取信息的请求：&nbsp;
            </p>
            <p><br /></p>
            <p>1、与个人信息控制者履行法律法规规定的义务相关的；&nbsp;</p>
            <p><br /></p>
            <p>2、与国家安全、国防安全直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>3、与公共安全、公共卫生、重大公共利益直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>4、与刑事侦查、起诉、审判和判决执行等直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>
                5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；&nbsp;
            </p>
            <p><br /></p>
            <p>6、所涉及的个人信息是您自行向社会公众公开的；&nbsp;</p>
            <p><br /></p>
            <p>7、根据您要求签订和履行合同所必需的；&nbsp;</p>
            <p><br /></p>
            <p>
                8、从合法公开披露的信息中收集的您个人信息的，如合法的新闻报道、政府信息公开等渠道；&nbsp;
            </p>
            <p><br /></p>
            <p>
                9、维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；&nbsp;
            </p>
            <p><br /></p>
            <p>10、法律法规规定的其他情形。&nbsp;</p>
            <p><br /></p>
            <p>二、我们如何使用您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>
                （一）为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账号安全，我们会在以下情形中使用您的信息：&nbsp;
            </p>
            <p><br /></p>
            <p>1、实现本政策中“我们如何收集您的个人信息”所述目的。&nbsp;</p>
            <p><br /></p>
            <p>
                2、为了使您知晓使用我们服务的状态，我们会向您发送服务通知及提醒。&nbsp;
            </p>
            <p><br /></p>
            <p>3、根据法律法规或监管要求向相关部门进行报告。&nbsp;</p>
            <p><br /></p>
            <p>4、邀请您参与我们服务有关的客户调研。&nbsp;</p>
            <p><br /></p>
            <p>
                5、为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。&nbsp;
            </p>
            <p><br /></p>
            <p>
                6、当您申请惠有钱APP产品时，我们可能需要基于规则或者机器学习等技术手段生成您的风险特征信息。该类特征信息是基于本政策第一条所列收集的您的信息经匿名化或去标识化加工或整理后生成。该风险特征信息，我们将用于反欺诈、信用评估、逾期风险控制等为您提供产品或服务相关的目的。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （二）当我们展示您的个人信息时，我们会采用去标识化处理方式对您的信息进行脱敏展示，以保护您的信息安全。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （三）当我们要将您的个人信息用于本政策未载明的其它用途时，我们会按照法律规定通过确认协议、文案确认等形式再次征求您的明确授权同意。若您不同意再次授权，您可能无法使用该项服务，但不影响您使用其他服务。&nbsp;
            </p>
            <p><br /></p>
            <p>三、我们如何共享、转让、委托处理、公开披露您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>（一）共享&nbsp;</p>
            <p><br /></p>
            <p>
                我们不会与我们以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。目前，我们可能在以下情形中，共享您的个人信息：&nbsp;
            </p>
            <p><br /></p>
            <p>
                1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政机关、司法机关、互金协会等监管部门的要求，对外共享您的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、与关联公司共享：为便于我们基于统一的账号体系向您提供一致化服务，便于您进行统一管理、保障系统和账号安全，您的个人信息可能会在我们和我们的关联公司之间进行必要共享。但我们只会共享必要的个人信息，且受本政策中所声明目的的约束；我们的关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。&nbsp;
            </p>
            <p><br /></p>
            <p>
                3、我们以外的第三方在向您提供其他服务的过程中，若经您授权同意后，我们可能将您的个人信息（包括本政策第一条所列收集的信息、第二条第（一）款第6项所列风险特征信息）提供给该获得您授权的第三方服务提供者。&nbsp;
            </p>
            <p><br /></p>
            <p>
                4、在您主动选择情况下与业务合作伙伴共享：目前，我们的业务合作伙伴包括以下类型：&nbsp;
            </p>
            <p><br /></p>
            <p>
                （1）资金方及/或其信贷经理。您通过惠有钱贷款产品时，我们会根据您的选择，将您提供的手机号码、资质信息（包括姓名、性别、年龄、户籍、现居住地址、常用邮箱地址、教育程度、逾期信息、在贷情况、信用卡情况、社保情况、公积金情况、收入情况、职业状况、经营企业情况、房产状况、车辆状况、抵押状况、投保情况、紧急联系人姓名、联系电话及关系、本次贷款用途及可接受最高月还款额度）共享给提供贷款产品的资金方及/或其信贷经理，用于资金方对您进行授信评估，确定是否满足监管机构要求及最终是否向您放款，以实现您的借款交易目的。&nbsp;
            </p>
            <p><br /></p>
            <p>
                另外，当您通过惠有钱申请贷款产品时，我们需要将您提供的姓名、手机号码、身份证号码、银行卡号、开户行、开户行地址共享给向您提供贷款产品的资金方，为您绑定银行卡，用于资金方向您发放贷款、为您提供还款服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （2）贷款服务机构及/或其咨询顾问。您通过惠有钱申请贷款服务产品时，我们会根据您的选择，将您提供的手机号码、资质信息（包括姓名、性别、年龄、户籍、现居住地址、常用邮箱地址、教育程度、逾期信息、在贷情况、信用卡情况、社保情况、公积金情况、收入情况、职业状况、经营企业情况、房产状况、车辆状况、抵押状况、投保情况、紧急联系人姓名、联系电话及关系、本次贷款用途及可接受最高月还款额度）共享给提供贷款产品中介或咨询服务的贷款服务机构及/或其咨询顾问，用于贷款服务机构根据您的资质情况向您匹配适合的资金方，并协助您完成贷款申请，以实现您的借款交易目的。&nbsp;
            </p>
            <p><br /></p>
            <p>
                另外，当您通过惠有钱申请贷款服务产品时，我们需要将您提供的姓名、手机号码、身份证号码、银行卡号、开户行、开户行地址共享给向您提供贷款产品中介或咨询服务的贷款服务机构，为您绑定银行卡，用于资金方向您发放贷款、为您提供还款服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （3）信用机构及数据服务商。您通过惠有钱申请产品或服务时，我们可能会将您提供的姓名、手机号码、身份证号码共享给信用机构、提供数据服务的第三方，用于获取您的身份识别信息、风险识别信息，资质评估信息、表征信用情况的综合评分或信用评级，用于对您的信用状况进行评估，以为您提供您选择的金融产品或服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                对我们与之共享您个人信息的第三方，我们会对其进行数据安全评估并与其签署严格的保密协定，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们将要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。在结束共享合作后，我们会要求第三方返还或删除通过共享获取的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>（二）转让&nbsp;</p>
            <p><br /></p>
            <p>
                我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：&nbsp;
            </p>
            <p><br /></p>
            <p>
                1、在获取明确同意的情况下转让：在告知并获得您的明确同意后，我们会向经您同意的其他方转让您的个人信息；&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、在涉及合并、收购、破产清算或类似交易时，如涉及到您个人信息转让，我们会向您告知有关情况，同时我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。&nbsp;
            </p>
            <p><br /></p>
            <p>
                3、基于法律法规、法律程序、诉讼或政府主管部门的强制性要求。&nbsp;
            </p>
            <p><br /></p>
            <p>&nbsp;（三）委托处理&nbsp;</p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>
                &nbsp;我们服务中的某些具体的模块或功能可能由外部供应商提供，例如我们会聘请服务提供商来协助我们提供客户支持。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>（四）公开披露&nbsp;</p>
            <p><br /></p>
            <p>我们仅会在以下情况下，公开披露您的个人信息：&nbsp;</p>
            <p><br /></p>
            <p>
                1、获得您明确同意后，以您明确同意的披露方式披露您所指定的个人信息；&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （五）共享、转让、公开披露个人信息时事先征得授权同意的例外&nbsp;
            </p>
            <p><br /></p>
            <p>
                以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：&nbsp;
            </p>
            <p><br /></p>
            <p>1、与个人信息控制者履行法律法规规定的义务相关的；&nbsp;</p>
            <p><br /></p>
            <p>2、与国家安全、国防安全直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>3、与公共安全、公共卫生、重大公共利益直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>4、与刑事侦查、起诉、审判和判决执行等直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>
                5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；&nbsp;
            </p>
            <p><br /></p>
            <p>6、您自行向社会公众公开的个人信息；&nbsp;</p>
            <p><br /></p>
            <p>
                7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。&nbsp;
            </p>
            <p><br /></p>
            <p>四、我们如何保护您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>（一）数据安全技术及管理措施&nbsp;</p>
            <p><br /></p>
            <p>
                为了您的信息安全，我们会采用符合业界标准的安全防护措施，包括采用安全技术、建立合理的制度规范来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。&nbsp;
            </p>
            <p><br /></p>
            <p>
                我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。我们对收集的您的个人信息均采取安全的加密技术去标识化处理后再行存储；我们使用受信赖的保护机制防止数据遭到恶意攻击；我们采用严格的数据访问权限控制、权限审批流程、监控控制及多重身份认证技术，确保仅有知悉必要的授权人员才可访问您的个人信息，避免数据被违规使用。&nbsp;
            </p>
            <p><br /></p>
            <p>
                我们已取得了以下认证：惠有钱在信息安全方面已达到信息安全等级保护三级等国际及国内权威认证标准的要求，并已获得了相应的认证。&nbsp;
            </p>
            <p><br /></p>
            <p>（二）惠有钱为保护个人信息采取的其他安全措施&nbsp;</p>
            <p><br /></p>
            <p>
                我们通过建立数据安全管理规范、数据分类分级制度、数据安全开发规范来管理规范个人信息的存储和使用。我们通过与信息接触者签订保密协议并进行背景调查、建立监控和审计机制来对数据进行全面安全控制，如果第三方未履行保密义务，可能会被我们追究法律责任并被我们终止合作。我们通过举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （三）我们会采取一切合理可行的措施，确保未向您收集与您使用我们服务功能无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。超出上述保存期限后，我们会对您的个人信息进行删除或匿名化处理。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （四）互联网环境并非百分之百安全，我们建议您通过安全方式、使用复杂密码，并注意保护您的账户及个人信息安全。我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将全力配合保护您的权益，并依法承担我们应承担的相应法律责任。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。&nbsp;
            </p>
            <p><br /></p>
            <p>（五）安全事件处置&nbsp;</p>
            <p><br /></p>
            <p>
                为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件的处理流程。&nbsp;
            </p>
            <p><br /></p>
            <p>
                1、我们为安全事件建立了专门的数据安全团队，按照安全事件处置规范要求，针对不同安全事件设置不同的安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、
                在不幸发生个人信息安全事件后，我们将按照最高优先级启动应急预案，组成应急响应小组，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，并在最短时间内追溯原因并减少损失。&nbsp;
            </p>
            <p><br /></p>
            <p>
                3、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知、短信通知等您预留的联系方式告知您，难以逐一告知您时，我们会采取合理、有效的方式发布公告。&nbsp;
            </p>
            <p><br /></p>
            <p>
                同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （六）如果您对我们的个人信息保护有任何疑问，可通过本政策约定的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策的联系方式联络我们，以便我们及时采取相应措施。&nbsp;
            </p>
            <p><br /></p>
            <p>五、您如何管理自己的个人信息&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;我们非常重视您对您个人信息的管理，按照国家相关法律、法规及标准，我们保障您对自己的个人信息行使以下权利：&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>&nbsp;（一）访问您的个人信息&nbsp;</p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式访问：您可以通过访问惠有钱产品-我的页面进行访问，您也可以通过惠有钱官方微信yiwan308进行访问。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>我们将在15个工作日内回复您的访问请求。&nbsp;</p>
            <p><br /></p>
            <p>（二）更正您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>
                当您发现我们处理的关于您的个人信息存在错误时，您有权要求我们作出更正。如果您想行使更正权，可以通过以下方式更正：您可以通过访惠有钱产品-我的页面作出更正，您也可以通过惠有钱官方微信yiwan308进行更正。&nbsp;
            </p>
            <p><br /></p>
            <p>我们将在15个工作日内回复您的更正请求。&nbsp;</p>
            <p><br /></p>
            <p>（三）删除您的个人信息&nbsp;</p>
            <p><br /></p>
            <p>在以下情形中，您可以向我们提出删除个人信息的请求：&nbsp;</p>
            <p><br /></p>
            <p>1、如果我们处理个人信息的行为违反法律法规；&nbsp;</p>
            <p><br /></p>
            <p>2、如果我们收集、使用您的个人信息，却未征得您的同意；&nbsp;</p>
            <p><br /></p>
            <p>3、如果我们处理个人信息的行为违反了与您的约定；&nbsp;</p>
            <p><br /></p>
            <p>
                4、如果您不再使用我们的产品或服务，如果您注销了惠有钱账户；&nbsp;
            </p>
            <p><br /></p>
            <p>5、如果我们不再为您提供产品或服务。&nbsp;</p>
            <p><br /></p>
            <p>
                若我们决定响应您的删除请求，我们还将同时通知从我们处获得您的个人信息的第三方，要求其及时删除，除非法律法规另有规定，或这些第三方获得了您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。&nbsp;
            </p>
            <p><br /></p>
            <p>我们将在15个工作日内回复您的删除请求。&nbsp;</p>
            <p><br /></p>
            <p>（四）管理您的授权范围&nbsp;</p>
            <p><br /></p>
            <p>
                每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。&nbsp;
            </p>
            <p><br /></p>
            <p>
                您可以通过以下方式操作：您可以通过关闭设备功能或通过惠有钱官方微信yiwan308撤回您的授权。&nbsp;
            </p>
            <p><br /></p>
            <p>
                当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。&nbsp;
            </p>
            <p><br /></p>
            <p>（五）注销账户&nbsp;</p>
            <p><br /></p>
            <p>
                您随时可注销此前注册的账户，您可以通过以下方式自行操作：您可以在我们的产品中（注销路径：我的—注销—注销账户即可）直接申请注销账户或者通过惠有钱官方微信yiwan308联系我们协助注销您的账户。&nbsp;
            </p>
            <p><br /></p>
            <p>
                您注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，我们将删除您的个人信息，但法律法规另有规定的除外。&nbsp;
            </p>
            <p><br /></p>
            <p>我们将在15个工作日内回复您的注销请求。&nbsp;</p>
            <p><br /></p>
            <p>（六）约束信息系统自动决策&nbsp;</p>
            <p><br /></p>
            <p>
                在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将在不侵害惠有钱商业秘密或其他用户权益、社会公共利益的前提下提供适当的救济方式。&nbsp;
            </p>
            <p><br /></p>
            <p>（七）响应您的上述请求&nbsp;</p>
            <p><br /></p>
            <p>
                为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求，但我们最长将自您提出请求之日起不超过十五个工作日内予以回复。如您不满意，还可以通过以下途径投诉：&nbsp;
            </p>
            <p><br /></p>
            <p>
                请将您的问题发送至惠有钱隐私保护邮件组（yiwanweilai@163.com）。&nbsp;
            </p>
            <p><br /></p>
            <p>
                对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
            </p>
            <p><br /></p>
            <p>
                在以下情形中，按照法律法规等要求，我们将无法响应您的请求：&nbsp;
            </p>
            <p><br /></p>
            <p>1、与个人信息控制者履行法律法规规定的义务相关的；&nbsp;</p>
            <p><br /></p>
            <p>2、与国家安全、国防安全直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>3、与公共安全、公共卫生、重大公共利益直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>4、与刑事侦查、起诉、审判和执行判决等直接相关的；&nbsp;</p>
            <p><br /></p>
            <p>5、有充分证据表明您存在主观恶意或滥用权利的；&nbsp;</p>
            <p><br /></p>
            <p>
                6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；&nbsp;
            </p>
            <p><br /></p>
            <p>
                7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；&nbsp;
            </p>
            <p><br /></p>
            <p>8、涉及商业秘密的。&nbsp;</p>
            <p><br /></p>
            <p>
                如果我们决定不响应您的请求，将向您告知该决定的理由，并向您提供投诉的途径。&nbsp;
            </p>
            <p><br /></p>
            <p>六、我们如何处理未成年人的个人信息&nbsp;</p>
            <p><br /></p>
            <p>
                （一）我们非常重视对未成年人个人信息的保护。我们的服务面向年满18周岁的成年人（且非为在校学生）。若您是18周岁以下的未成年人，我们建议您不要使用我们的服务。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （二）若您必须要使用我们的服务时，应事先取得您的父母或法定监护人的书面同意或由您的父母或法定监护人代替您操作。我们将根据国家相关法律法规的规定保护未成年人的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （三）对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或法定监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （四）若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请及时与我们联系。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （五）如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人个人信息的，则我们会设法尽快删除相关数据。&nbsp;
            </p>
            <p><br /></p>
            <p>七、您个人信息的存储地点及存储时间&nbsp;</p>
            <p><br /></p>
            <p>
                （一）我们在中华人民共和国境内收集您的个人信息，并将您的个人信息全部存储于中华人民共和国境内。目前，我们不会将您的个人信息传输至境外。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （二）我们仅在为实现本服务目的所必需的最短时间内保留您的个人信息，法律法规另有规定或者您另行授权同意的除外。&nbsp;
            </p>
            <p><br /></p>
            <p>如超出上述保存期限，我们会将您的信息删除或匿名化处理。&nbsp;</p>
            <p><br /></p>
            <p>
                （三）如果我们终止服务或运营，我们会至少提前十五个工作日向您通知，并在终止服务或运营后对存储的您的个人信息进行删除或匿名化处理。&nbsp;
            </p>
            <p><br /></p>
            <p>八、对第三方责任的声明&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;请您注意，本政策仅适用于惠有钱自行向您提供的产品或服务。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>
                &nbsp;如果第三方服务商通过惠有钱为您提供服务，当您进入第三方服务商的服务页面时，请注意相关服务由第三方向您提供。涉及到第三方向您收集信息的，建议您仔细查看第三方的隐私政策或协议约定。当您查看第三方的服务页面（包括第三方开发的应用程序或第三方创建的网页）时，这些第三方可能会放置自己的Cookie或其同类技术，这些Cookie或其同类技术不受我们的控制，且其使用不受本政策的约束。我们将努力要求上述第三方主体对您的个人信息采取保护措施。如您发现上述第三方应用程序（或网页）存在风险时，建议您立即终止相关操作。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;请您知悉，惠有钱
                APP的部分服务需要由我们的合作伙伴共同为您提供，因此，惠有钱
                APP内将嵌入合作伙伴的软件工具开发包（以下简称“SDK”），我们将逐项列举嵌入SDK的来源、目的、收集信息类型，具体内容详见附件一。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>&nbsp;九、本政策的适用及修订&nbsp;</p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>
                &nbsp;（一）惠有钱所有服务均适用本政策，但某些特定服务还将适用特定的隐私保护政策（例如授权书、授权委托书），我们将在向您提供这些特定服务前进一步向您说明并获取您的授权同意。如特定的隐私保护政策与本政策有不一致之处，以特定的隐私保护政策为准。特定的隐私保护政策未提及之处，以本隐私保护政策为准。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;（二）我们的个人信息保护政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                对于重大变更，我们还会提供更为显著的通知。如本政策发生重大变更，我们将在惠有钱官方发布公告或以推送通知、发送短信、拨打电话的方式来通知您，并于本政策更新后再次获取您对于变更后隐私政策的明示授权同意。为了您能及时接收到通知，建议您在手机号码更新时及时通知我们。若您在本政策修订且接到我们的通知后，点击确认或下一步，这表示您已充分阅读、理解并接受修订后的本政策。&nbsp;
            </p>
            <p><br /></p>
            <p>本政策所指的重大变更包括但不限于：&nbsp;</p>
            <p><br /></p>
            <p>
                1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；&nbsp;
            </p>
            <p><br /></p>
            <p>
                2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；&nbsp;
            </p>
            <p><br /></p>
            <p>3、个人信息共享、转让或公开披露的主要对象发生变化；&nbsp;</p>
            <p><br /></p>
            <p>
                4、您参与个人信息处理方面的权利及其行使方式发生重大变化；&nbsp;
            </p>
            <p><br /></p>
            <p>
                5、
                我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；&nbsp;
            </p>
            <p><br /></p>
            <p>6、个人信息安全影响评估报告表明存在高风险。&nbsp;</p>
            <p><br /></p>
            <p>十、如何联系我们&nbsp;</p>
            <p><br /></p>
            <p>
                （一）如果您对本政策或您在使用我们的服务过程中有任何疑问、意见或建议，您均可通过以下方式与我们取得联系：&nbsp;
            </p>
            <p><br /></p>
            <p>
                负责人及联系方式：惠有钱隐私保护邮件组（yiwanweilai@163.com）。&nbsp;
            </p>
            <p><br /></p>
            <p>
                &nbsp;（二）为了保障您的信息要求，我们处理您的问题前，需要先验证您的身份，但我们最长将自您提出疑问、意见或建议之日起不超过15个工作日内予以回复。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>&nbsp;十一、本政策中关键词说明&nbsp;</p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p>
                &nbsp;（一）惠有钱：是由海南亿万未来科技有限公司运营的，通过大数据分析，为个人消费者、小微企业、个体工商户提供金融产品的搜索、匹配等服务、并为银行、消费金融公司和网络小贷公司等金融机构提供专业一站式风控等服务。
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                &nbsp;（二）用户：指注册使用惠有钱的个人用户，以下称“您”或“最终用户”。&nbsp;
            </p>
            <p>&nbsp;</p>
            <p><br /></p>
            <p>
                （三）个人信息：以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。&nbsp;
            </p>
            <p><br /></p>
            <p>
                （四）个人敏感信息：一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。&nbsp;
            </p>
            <p><br /></p>
            <p>附件一：第三方SDK目录&nbsp;</p>
            <p><br /></p>
            <p>
              说明：我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息）以提供统计分析服务， 并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。 （https://ask.dcloud.net.cn/protocol.html）
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "yinsi",
};
</script>

<style scoped></style>
